import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext"
import { Stepper } from "@/view/components/ui/stepper"

export const Steps = () => {
  const { step } = useSelfHiringContext()

  return (
    <div className="border border-gray02 flex flex-col gap-3 items-center justify-center bg-white rounded-xl py-4 px-6">
      <div className="flex text-center flex-col items-center justify-center gap-2 md:gap-0	">
        <div className="leading-none text-md sm:text-lg font-semibold">
          Conclua seu empréstimo com poucos passos
        </div>
        <div className="text-sm sm:text-base">e tenha o valor em sua conta rapidamente</div>
      </div>

      <Stepper
        steps={[
          { label: 'Cadastro' },
          { label: 'Simulação' },
          { label: 'Finalização' },
          { label: 'Formalização' },
        ]}
        currentStep={step}
      />

    </div>
  )
}